import React from 'react';
import '../styles/confirm-dialog.css';

/**
 * Modal de confirmación reutilizable
 * @param {boolean} isOpen - Si el modal está visible
 * @param {string} title - Título del modal
 * @param {string} message - Mensaje principal
 * @param {string} detail - Detalle adicional (opcional)
 * @param {string} confirmText - Texto del botón confirmar (default: "Eliminar")
 * @param {string} cancelText - Texto del botón cancelar (default: "Cancelar")
 * @param {function} onConfirm - Función al confirmar
 * @param {function} onCancel - Función al cancelar
 * @param {boolean} isDangerous - Si es una acción peligrosa (rojo)
 */
const ConfirmDialog = ({
  isOpen,
  title = '⚠️ Confirmar Acción',
  message = '¿Estás seguro?',
  detail = null,
  confirmText = 'Eliminar',
  cancelText = 'Cancelar',
  onConfirm,
  onCancel,
  isDangerous = true
}) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="confirm-dialog-overlay" onClick={handleBackdropClick}>
      <div className="confirm-dialog">
        <div className="confirm-header">
          <h2>{title}</h2>
          <button className="confirm-close" onClick={onCancel}>✕</button>
        </div>

        <div className="confirm-body">
          <p className="confirm-message">{message}</p>
          {detail && <p className="confirm-detail">{detail}</p>}
          {isDangerous && (
            <p className="confirm-warning">
              ⚠️ Esta acción NO se puede deshacer.
            </p>
          )}
        </div>

        <div className="confirm-footer">
          <button 
            className="btn-secondary"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button 
            className={isDangerous ? 'btn-danger' : 'btn-primary'}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
